<template>
    <div v-if="show_demo">
        <select class="ui dropdown" v-dropdown v-model="current_melody">
            <option value="">{{ $t('ui.general.please_select') }}</option>
            <option
                v-for="(melody, key) in default_melodies"
                :value="key">
                {{ key }}
            </option>
        </select>
        <div class="ui basic button" @click="$bus.$emit(channel, 'play_sound', current_melody)">
            <i class="play icon"></i>Play
        </div>
        <select class="ui dropdown" v-dropdown v-model="current_file">
            <option value="">{{ $t('ui.general.please_select') }}</option>
            <option
                v-for="file in default_files"
                :value="file">
                {{ file }}
            </option>
        </select>
        <div class="ui basic button" @click="$bus.$emit(channel, 'play_file', current_file)">
            <i class="play icon"></i>PlayFile
        </div>
    </div>
</template>

<script>
export default {
    name: "ToolWebAudioMain",
    props: {
        channel: String,
        show_demo: Boolean,
        allow_overlay_play: Boolean,
    },
    data() {
        return {
            current_melody: null,
            current_file: null,
            web_audio_api: {
                context: 'webkitAudioContext' in window ? new webkitAudioContext():new AudioContext(),
                oscillator: null,
                oscillators: [],
            },
            default_files: [
                "AlertSound.mp3",
                "收貨.mp3",
                "進站.mp3",
                "派件中.mp3",
                "已配達.mp3",
                "回站.mp3",
                "異常件.mp3",
                "異常件問題排除.mp3",
                "寄件者退運.mp3",
                "出站集貨中轉.mp3",
                "聯運.mp3",
                "鎖定.mp3",
                "解除鎖定.mp3",
            ],
            default_melodies: {
                ok: [
                    {
                        type: "sawtooth",
                        frequency: 1800,
                        detune: 800,
                        begin_at: 0,
                        end_at: 0.12,
                    },
                    {
                        type: "sawtooth",
                        frequency: 1500,
                        detune: 800,
                        begin_at: 0.15,
                        end_at: 0.27,
                    },
                ],
                alert: [
                    {
                        type: "triangle",
                        frequency: 400,
                        detune: 0,
                        begin_at: 0,
                        end_at: 0.06,
                    },
                    {
                        type: "triangle",
                        frequency: 400,
                        detune: 0,
                        begin_at: 0.08,
                        end_at: 0.14,
                    },
                ],
                error: [
                    {
                        type: "sawtooth",
                        frequency: 100,
                        detune: 800,
                        begin_at: 0,
                        end_at: 0.1,
                    },
                    {
                        type: "sawtooth",
                        frequency: 100,
                        detune: 800,
                        begin_at: 0.13,
                        end_at: 0.2,
                    }
                ],
            }
        }
    },
    computed: {
    },
    created() {

    },
    mounted() {
        this.$bus.$off(this.channel)
        this.$bus.$on(this.channel, (play_type, name) => {
            switch (play_type) {
                case "play_sound":
                    this.play_sound(name)
                    break
                case "play_file":
                    this.play_file(name)
                    break
                default:

            }
        })

        $('body').click((event) => {
            this.web_audio_api.context.resume()
        })
    },
    watch: {
    },
    methods: {
        play_sound(melody_name) {
            if (!this.allow_overlay_play) {
                this.stop()
            }

            var melody = this.default_melodies[melody_name]

            _.forEach(melody, (note, index) => {
                this.web_audio_api.oscillators[index] = this.web_audio_api.context.createOscillator()
                this.web_audio_api.oscillators[index].type = note.type
                this.web_audio_api.oscillators[index].frequency.value = note.frequency
                this.web_audio_api.oscillators[index].detune.value = note.detune
                this.web_audio_api.oscillators[index].connect(this.web_audio_api.context.destination)

                this.web_audio_api.oscillators[index].start(this.web_audio_api.context.currentTime + note.begin_at)
                this.web_audio_api.oscillators[index].stop(this.web_audio_api.context.currentTime + note.end_at)
            })
        },
        stop() {
            _.forEach(this.web_audio_api.oscillators, (oscillator) => {
                oscillator.disconnect()
            })
        },
        play_file(file_name) {
            if (!this.allow_overlay_play) {
                this.stop()
            }
            // const URL = 'https://s3-us-west-2.amazonaws.com/s.cdpn.io/123941/Yodel_Sound_Effect.mp3'
            const URL = '/audios/' + file_name

            let file_buffer

            // Axios Version File Buffer
            axios.get(URL, {responseType: 'arraybuffer'})
                .then(response => {
                    return response.data
                })
                .then(arrayBuffer => {
                    return this.web_audio_api.context.decodeAudioData(arrayBuffer, (audioBuffer) => {
                        file_buffer = audioBuffer
                        play(file_buffer)
                    })
                })

            // Original File Buffer
            // window.fetch(URL)
            //     .then(response => response.arrayBuffer())
            //     .then(arrayBuffer => this.web_audio_api.context.decodeAudioData(arrayBuffer))
            //     .then(audioBuffer => {
            //         file_buffer = audioBuffer
            //         play(file_buffer)
            //     })

            var that = this
            function play(audioBuffer) {
                that.web_audio_api.oscillators[0] = that.web_audio_api.context.createBufferSource()
                that.web_audio_api.oscillators[0].buffer = audioBuffer
                that.web_audio_api.oscillators[0].connect(that.web_audio_api.context.destination)
                that.web_audio_api.oscillators[0].start()
            }
        }
    },
    components: {
    },
}
</script>

<style scoped lang="scss">
</style>
